import {useState, useRef} from "react";
import { Box, Typography, IconButton, List, ListItem, Stack, Grid } from "@mui/material"
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import Grilling from '../assets/meat-sizzle-desktop-reduced.webm'
import GrillingPhone from '../assets/meat-sizzle-mobile-lq.webm'
import './landingPage.css'
import InstagramIcon from '../assets/instagram-logo.webp'
import EmailRestAPI from "../components/EmailRestAPI";
import { useScrollPosition } from "@n8tb1t/use-scroll-position"
import CCText from '../assets/cc-text.webp'
import CCTextMobile from '../assets/cc-text-mobile.webp'
import CCLogo from '../assets/CharcoalCrazeLogoRed.webp'
import { YelpReviewWidget } from "../components/yelp-reviews/YelpReviewWidget";
import VendingSchedule from "./VendingSchedule";
import vendingSchedule from '../../vendingSchedule.json'
import { NavLink } from "react-router-dom";
import dayjs from "dayjs";
import {motion, useScroll, useTransform} from 'motion/react'
import { Paragraph } from "../components/animated-elements/RevealWord";
import CharcoalBG from "../assets/charcoal-bed.webp"
import { ParallaxedBg } from "../components/animated-elements/ParallaxBg";
import GrilledChicken from '../assets/chickenPlated.webp'
import BrisketPlate from '../assets/brisketPlate.webp'
import BrisketBurntEnds from '../assets/brisketBurntEnds.webp'
import BrisketBurrito from '../assets/brisketBurrito.webp'
import Tritip from '../assets/platedTritip.webp'
import SutDolma from '../assets/veganDolma.webp'
import StuffedJalapenos from '../assets/stuffedJalapenos.webp'
import { Info } from "@mui/icons-material";

const location = `
https://www.google.com/maps/place/34%C2%B009'39.2%22N+118%C2%B017'19.7%22W/@34.160907,-118.2888162,59m/data=!3m1!1e3!4m4!3m3!8m2!3d34.160892!4d-118.288793?entry=ttu&g_ep=EgoyMDI0MDgyOC4wIKXMDSoASAFQAw%3D%3D
`

/*
//// Use to  configure get request for yelp reviews

const options = {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: 'bearer 4aRZt7u5A8ofCKSpfMxq5D1f3Tn7uPtgsQKKlMkAl_Hc_FHsDUaIL1wsXyc2mOZqGs5c-1n0ZrMlXno6E-S8xZAXtnZpngQTUZraNWUO45PcURdEmmV53Ub5Duh2Z3Yx'
    }
  };
  
  fetch('https://api.yelp.com/v3/businesses/YuzfrLFr4Tnl6nQerMgIEw/reviews?locale=en_US&offset=0&limit=20&sort_by=yelp_sort', options)
    .then(res => res.json())
    .then(res => console.log(res))
    .catch(err => console.error(err));

*/


/*
//// Use to get info about the business

const options = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    Authorization: 'bearer 4aRZt7u5A8ofCKSpfMxq5D1f3Tn7uPtgsQKKlMkAl_Hc_FHsDUaIL1wsXyc2mOZqGs5c-1n0ZrMlXno6E-S8xZAXtnZpngQTUZraNWUO45PcURdEmmV53Ub5Duh2Z3Yx'
  }
};

fetch('https://api.yelp.com/v3/businesses/YuzfrLFr4Tnl6nQerMgIEw?locale=en_US', options)
  .then(res => res.json())
  .then(res => console.log(res))
  .catch(err => console.error(err));

*/


function LandingPage() {

    const [trigger, setTrigger] = useState(false)
    const mainContainer = useRef(null)
      
    const { scrollYProgress } = useScroll({
        target: mainContainer,
        offset: ['start start', 'end end']
    })
    const yYelp = useTransform(scrollYProgress, [0, 1], ["15vh", "-10vh"]);

    const ySchedule = useTransform(scrollYProgress, [0, 1], ["10vh", "-10vh"]);
    const yImages = useTransform(scrollYProgress, [0, 1], ["10vh", "-20vh"]);

    const y = useTransform(scrollYProgress, [0, 1], ["10vh", "-10vh"]);

    useScrollPosition(({ prevPos, currPos }) => {
        const isShow = scrollYProgress.get() < .05
        if (!isShow) {
          setTrigger(true)
        } else {
          setTrigger(false)
        }
      }, [scrollYProgress])

    return (        
        <Box ref={mainContainer}>
            {/* Section 1: Landing */}
            <ParallaxedBg bgY={y} backgroundImage={CharcoalBG}/>
                 
            <Box sx={{ display: { xs: 'none', md: 'block'}}}>
                <Box 

                    sx={{
                        width:'100%', 
                        position: 'absolute',
                        marginTop: '4vw', 
                        transition:'opacity .5s ease-in-out', 
                        opacity: trigger? 0:1, 
                        zIndex: 100,
                        justifyContent:'center', alignItems:'center', textAlign:'center'
                    }}
                >
                    <Box width='100vw' mb='20px'>
                        <img
                            src={CCLogo} 
                            style={{  
                                maxWidth: '300px',
                                width: '25%', 
                                zIndex: 1,
                                filter: 'drop-shadow(0px 0px 3px rgba(0,0,0,1))', 
                            }} 
                        />
                    </Box>
                    <img 
                        src={CCText} 
                        style={{  
                            maxWidth:'50vw', 
                            zIndex: 1,
                            filter: 'drop-shadow(0px 0px 4px rgba(0,0,0,1))   contrast(1.5)', 
                        }} 
                    />
                    <Typography 
                        textAlign='center' 
                        variant="h2" 
                        sx={{ 
                            color: 'white', 
                            fontWeight:'bold', 
                            fontSize: 'clamp(30px, 2vw, 3vw)', 
                            zIndex: 1, 
                            filter: 'drop-shadow(0px 0px 2px rgba(0,0,0,1))', 
                            mt: '50px'
                        }} 
                    >
                        Savor the flavor
                    </Typography>
                </Box>
                <video src={Grilling} muted controls={false} autoPlay loop style={{ backgroundSize: 'cover', width: '100%', filter:'brightness(.9)'  }} /> 
            </Box>               
            <Box sx={{ display: { xs: 'block', md: 'none'}}}>               
                    <Box 
                        sx={{ 
                            position: 'absolute', 
                            marginTop: '10vh', 
                            transition:'opacity .5s ease-in-out', 
                            opacity: trigger? 0:1, 
                            zIndex: 100,
                            justifyContent:'center', alignItems:'center', textAlign:'center'
                        }}
                    >
                        <Box width='100vw' mb='20px'>
                            <img
                                src={CCLogo} 
                                style={{  
                                    maxWidth:'300px', 
                                    zIndex: 1,
                                    filter: 'drop-shadow(0px 0px 3px rgba(0,0,0,1))', 
                                }} 
                            />
                        </Box>
                        <img 
                            src={CCTextMobile} 
                            style={{  
                                maxWidth:'95vw',  
                                zIndex: 1,  
                                filter: 'drop-shadow(0px 0px 4px rgba(0,0,0,1))  contrast(1.5)'
                            }} 
                        />
                        <Typography 
                            textAlign='center' 
                            variant="h2" 
                            sx={{ 
                                marginTop:'50px',
                                color: 'white', 
                                fontWeight:'bold', 
                                fontSize: 'clamp(16px, 6vw, 24px)', 
                                zIndex: 1, 
                                filter: 'drop-shadow(0px 0px 2px rgba(0,0,0,1))', 
                            }} 
                        >
                            Savor the flavor
                        </Typography>
                    </Box>
                <video src={GrillingPhone} muted controls={false} autoPlay loop style={{ backgroundSize: 'cover', width: '100%', filter:'brightness(.9)'  }} /> 
            </Box>    
            {/* Section 2: Location */}
            <Box
                sx={{ 
                    textAlign: 'center',
                    alignItems:'center',
                    justifyContent:'center',
                    maxWidth:'1200px',
                    m:'auto',
                    mt: '-100px'
                }}
            >
                <motion.div style={{ y: ySchedule}}>
                    
                    <VendingSchedule data={vendingSchedule.schedule.filter(d => dayjs(d.date).isAfter(dayjs().subtract(1,'day'))).slice(0,5)}/>
                    <Box
                        sx={{ 
                            textAlign: 'center',
                            alignItems:'center',
                            justifyContent:'center',
                            maxWidth:'1200px',
                            m:'auto',
                            mt: '50px',
                            mb:'100px'
                        }}
                    >
                        <NavLink to={'/VendingSchedule'} className='nav-styles' style={{fontSize:'22px'}}>
                            See our full schedule!
                        </NavLink>
                    </Box> 

                   
                    {/* <Box
                        sx={{ 
                            textAlign: 'center',
                            alignItems:'center',
                            justifyContent:'center',
                            maxWidth:'1200px',
                            mx: { xs: '20px', sm: 'auto'},
                            mt: '50px',
                            mb:'100px',
                            border: '1px solid red',
                            borderRadius: '12px',
                            fontSize: '24px',
                            color: 'white',
                            backgroundColor: 'rgba(15,15,15,.7)',
                            padding: '18px',
                        }}
                    >
                        <Info sx={{color:'red', marginRight:'10px', verticalAlign:'middle', marginTop:'-6px'}}/>
                        Thank you for your interest in Charcoal Craze! <br/>
                        We will be out of town from the 16th of November through the 6th of December.
                    </Box> */}
                </motion.div>
            </Box>
             <Box 
                sx={{ 
                    textAlign: 'center',
                    alignItems:'center',
                    justifyContent:'center',
                    maxWidth:'1200px',
                    m:'auto',
                    mt:'150px',
                    width:{ xs: '80vw', md:'75vw', lg:'100vw'}
                }}
            >          
                <motion.div  style={{ y: yImages}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6} sx={{maxWidth: '400px'}}>
                            <motion.img src={BrisketBurntEnds} alt='Brisket Burnt Ends in sweet and spicy sauce.' style={{backgroundSize: 'contain', width:'100%', filter: 'drop-shadow(0px 10px 10px black)', borderRadius: '40px'}}/>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{maxWidth: '400px'}}>
                            <motion.img src={BrisketPlate} alt='Brisket plate with tzatziki, rice, carrot and cabbage salad and bbq sauce.' style={{backgroundSize: 'contain', width:'100%', filter: 'drop-shadow(0px 10px 10px black)', borderRadius: '40px'}}/>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{maxWidth: '400px'}}>
                            <motion.img src={BrisketBurrito} alt='Toasted brisket burrito.' style={{backgroundSize: 'contain', width:'100%', filter: 'drop-shadow(0px 10px 10px black)', borderRadius: '40px'}}/>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{maxWidth: '400px'}}>
                            <motion.img src={SutDolma} alt='Plated rice and herb stuffed sweet pepper dolma.' style={{backgroundSize: 'contain', width:'100%', filter: 'drop-shadow(0px 10px 10px black)', borderRadius: '40px'}}/>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{maxWidth: '400px', borderRadius: '40px'}}>
                            <motion.img src={Tritip} alt='Plated tritip with avocados.' style={{backgroundSize: 'contain', width:'100%', filter: 'drop-shadow(0px 10px 10px black)', borderRadius: '40px'}}/>
                        </Grid>
                        <Grid item xs={12} md={6} sx={{maxWidth: '400px'}}>
                            <motion.img src={GrilledChicken} alt='Plated grilled chicken with tomatoes and parsley.' style={{backgroundSize: 'contain', width:'100%', filter: 'drop-shadow(0px 10px 10px black)', borderRadius: '40px'}}/>
                        </Grid>
                        
                        {/* <Grid item xs={12} md={6} sx={{maxWidth: '400px'}}>
                            <motion.img src={StuffedJalapenos} alt='Stuffed jalapenos filled with cream cheese and wrapped with bacon.' style={{backgroundSize: 'contain', width:'100%', filter: 'drop-shadow(0px 10px 10px black)'}}/>
                        </Grid> */}
                    </Grid>
                </motion.div>         
            </Box>
            <Box 
                sx={{ 
                    textAlign: 'center',
                    alignItems:'center',
                    justifyContent:'center',
                    maxWidth:'1200px',
                    m:'auto',
                    mt:'50px',
                    width:{ xs: '80vw', md:'75vw', lg:'100vw'}
                }}
            >          
                <motion.div style={{ y: yYelp}}>
                    <YelpReviewWidget/>
                </motion.div>         
            </Box>
            
            <Box>   
                <motion.div style={{y}}>
                    <Box
                        sx={{
                            mt: '50px',
                            fontSize: {xs: '12px', md: '20px'},
                            color: 'white',
                            textAlign: 'center',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mx: 'auto',
                            maxWidth: '1000px',
                            pl: '5vw',
                            pr: '5vw'
                        }}
                    >
                        <Paragraph paragraph='Open for catering and at select breweries every day except Tuesday. For catering requests please give us at least 5 days notice, as all of our food is prepared fresh!'  magnitude={20} horizontalDirection="right" verticalDirection="top"/>
                    </Box>
                </motion.div>
                <motion.div style={{y}}>
                    <Typography 
                        sx={{
                            mt: '10px',
                            fontSize: '15px',
                            color: 'white',
                            textAlign: 'center',
                            mx: 'auto'
                        }}>
                            Grilled Meats are usually prepared on site.
                    </Typography>
                </motion.div>
            </Box>
            <motion.div style={{y}}>
                <Box 
                    sx={{ 
                        maxWidth: { xs: '100%', sm: "600px"}, 
                        height: { xs: '100%'}, 
                        bgcolor: '#212021', 
                        mx: 'auto', 
                        borderRadius: '15px',
                        mt: '35px',
                        pt: '15px',
                        pb: '15px'
                    }}
                >
                    <Typography
                        sx={{
                        
                            fontSize: '16px',
                            color: 'white',
                            textAlign: 'center',
                            mx: 'auto'
                        }}
                    >
                        Please text or email us to arrange a call:
                    </Typography>
                
                    <Typography sx={{
                        textAlign: 'center',
                        mx: 'auto',
                        mt: '15px'
                    }}>                        
                        <a 
                            style={{                        
                                color: 'white', 
                                textDecoration: 'none'
                            }} 
                            href="tel:+18182939445"
                        >
                            1 (818) 293 - 9445
                        </a>                                                   
                    </Typography>
                    <Typography sx={{ 
                        mt: '5px',
                        fontSize: '16px',
                        color: 'white',
                        textAlign: 'center',
                        mx: 'auto'
                    }}>
                        charcoalcraze@gmail.com
                    </Typography>
                </Box>
            </motion.div>
            <Box  
                mt={4}
                sx={{ 
                    mx: 'auto', 
                    textAlign: 'center', 
                }}
            >
                <Typography fontSize={32} color='white' mb={4} mt={10}>
                    Follow us on Instagram
                </Typography>

                <IconButton
                  size="large"
                //   onClick={()=>console.log('to instagram')}
                  href='https://www.instagram.com/charcoalcraze/'  rel='norefferer noopener' target="_blank"
                  sx={{
                    
                    transition: "all 0.3s ease-in-out",
                    opacity: 0.7,
                    height: '100px',
                    width: '100px',
                    ":hover": { opacity: 1 },
                  }}
                >
                  <img src={InstagramIcon} style={{height:'100px', width:'100px'}}/>
                </IconButton>
            </Box>
            {/* Section 3: Catering Calendar */}
            <Box>
                <Box id='bookEvent'>
                    <Typography 
                        sx={{ 
                            color: '#FFFFFF', 
                            textAlign: 'center', 
                            mt: '50px', 
                            fontSize: '32px',
                            px: '5%'
                        }}
                    >
                        Want delicious Armenian / American Fusion BBQ catered at your event?
                    </Typography>
                </Box>         
            </Box>
            {/* Section 4: Contact Form */}         
            <Box 
                sx={{ 
                    mx: 'auto', 
                    textAlign: 'center', 
                    mt: '40px'
                }}
            >
                <Typography 
                    sx={{ 
                        fontSize: '28px', 
                        color: 'white'
                    }}
                >
                    Contact Us
                </Typography>    
                <EmailRestAPI />
            </Box> 
            {/* Section 5: Footer */}
            <Box 
                sx={{ 
                    textAlign: 'center',
                    mt: '65px',
                    mb: '25px'
                }}
            >
                <Typography 
                    sx={{ 
                        color: 'white',
                        mx: 'auto'
                    }}
                >
                    Copyright © Charcoal Craze LLC 2024
                </Typography>
                <Typography sx={{ mx: '5px'}}>                        
                    <a 
                        style={{                        
                            color: 'white', 
                            textDecoration: 'none'
                        }} 
                        href="tel:+18182939445"
                    >
                        Phone: +1 818 293 9445
                    </a>                               
                </Typography>
            </Box>
        </Box>
    )
}

export default LandingPage